export default "__VITE_ASSET__706951c2__"